import PoliceCheckTable from './components/PoliceCheckTable';
import React, { useState, useEffect } from 'react';
import axios from '../../../api/axios';
import {
  columnsDataCheck,
} from "./variables/columnsData";

const ApprovedByMrepo = () => {
  const [data, setData] = useState([]);
 
  useEffect(() => {
    const fetchData = async () => {
      const storedToken = localStorage.getItem("token"); 
      
      let token = "Bearer " + storedToken.replace(/"/g, '');
      const headers = {
        Authorization: token,
        "Content-Type": "application/json",
      };
      try {
        const response = await axios.get("/api/reports/approvedMrepo", {
        headers 
        });
        setData(response.data , "mrepo data");
      } catch (error) {
      }
    };
    fetchData();
  }, []);
 //console.log(data, "datadadas")
  return (
    <div>
      <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1">
        <PoliceCheckTable columnsData={columnsDataCheck} tableData={data} />
      </div>
    </div>
  );
};

export default ApprovedByMrepo;
